import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '../../components';
import { PurchasesView, requireMarketEnabled } from '../../features/market';

export const Route = createFileRoute('/_auth/purchases')({
  beforeLoad: requireMarketEnabled,
  component: () => (
    <PageContainer>
      <PurchasesView />
    </PageContainer>
  ),
});
